function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2702",
  "data-name": "Path 2702",
  d: "M3 3v34h34V3H3M0 0h40v40H0z",
  fill: "#fff"
})));